import axios from 'axios'
import { applyInterceptors } from '../interceptors'

const headerParameterName = {
  REQUEST_CLIENT_ID: 'x-request-client-id',
} as const

const clientId = 'ta-appointment-ui'

const service = (baseUrl: string) => {
  const executor = axios.create({ baseURL: baseUrl, headers: { [headerParameterName.REQUEST_CLIENT_ID]: clientId } })

  applyInterceptors(executor)

  return executor
}

export { service }
